import { Button, Col, Row, Spinner2, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { GameDetailModal, GameItem } from './components';

const Games = ({ team, limit = 5, onViewMore }) => {
  const [games, setGames] = useState([]),
    [loading, setLoading] = useState(true),
    [total, setTotal] = useState(0),
    [selectedGame, setSelectedGame] = useState(null);

  useEffect(() => {
    if (!team?._id) return;

    fetchGames();
  }, [team?._id]);

  async function fetchGames() {
    setLoading(true);

    const res = await Api.post('/admin/games/get', {
      teamId: team._id,
      sortBy: { date: -1 },
      limit: limit
    });

    if (!res) {
      setLoading(false);
      return;
    }

    setGames(res.games || []);
    setTotal(res.total || 0);
    setLoading(false);
  }

  const handleGameClick = (game) => {
    setSelectedGame(game);
  };

  const handleCloseModal = () => {
    setSelectedGame(null);
  };

  if (!team) return null;

  return (
    <Col marg="40px 0 0" noFlex wid="100%">
      <Row between centerAll marg="0 0 24px" wid="100%">
        <Text h4 bold>
          Games
        </Text>
        <Text b2 col={theme.GREY_60} marg="0 0 0 24px">
          {total} total
        </Text>
      </Row>

      {loading ? (
        <Col center pad="40px 0">
          <Spinner2 />
        </Col>
      ) : games.length === 0 ? (
        <Col center pad="40px 0">
          <Text b2 col={theme.GREY_60}>
            No games found
          </Text>
        </Col>
      ) : (
        <>
          <Col noFlex wid="100%" gap="12px">
            {games.map((game) => (
              <GameItem key={game._id} game={game} teamId={team._id} onClick={handleGameClick} />
            ))}
          </Col>

          {total > limit && onViewMore && (
            <Button
              text={`View All ${total} Games`}
              onClick={onViewMore}
              marg="16px 0 0"
              wid="100%"
              bordered
            />
          )}
        </>
      )}

      <GameDetailModal visible={!!selectedGame} closeModal={handleCloseModal} game={selectedGame} teamId={team._id} />
    </Col>
  );
};

export default Games;
